import { Zap, Coffee, Armchair, ShoppingBag, Leaf } from "lucide-react";
import { FEATURES } from "@/lib/content";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/primitives";

const ICONS = { Zap, Coffee, Armchair, ShoppingBag, Leaf };

export default function FeatureStrip() {
  return (
    <section className="border-y border-white/10 bg-rp-surface" data-testid="feature-strip">
      <div className="mx-auto max-w-7xl px-6 py-20 md:px-12 md:py-28">
        <Reveal>
          <SectionHeading overline="Overview" title={<>A Next-Generation<br />Travel Destination</>} />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-5">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[f.icon];
            return (
              <Reveal
                key={f.title}
                delay={i * 0.06}
                className="group relative bg-rp-card p-8 transition-colors duration-300 hover:bg-[#0f0f0f]"
              >
                <div data-testid={`feature-card-${i}`}>
                  <div className="grid h-12 w-12 place-items-center rounded-xl border border-white/10 text-rp-accent transition-colors duration-300 group-hover:border-rp-accent/50 group-hover:shadow-glow-sm">
                    <Icon className="h-6 w-6" strokeWidth={1.5} />
                  </div>
                  <h3 className="mt-6 font-display text-lg font-medium tracking-tight text-white">{f.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-white/55">{f.text}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
